module.exports = "/_next/static/images/apple-icon-144x144-64a24269c6d6ca0674cb323add7fc784.png";